import { useEffect, useState } from 'react';

const START = 178;
const END = 214;
const RISE_MS = 5200;
const HOLD_MS = 2600;

const smoothstep = (t: number) => t * t * (3 - 2 * t);

interface RoastClock {
  temp: number;
  // Частка всього циклу (нагрів + пауза), 0…1 — за нею фарбується й «розбухає» зерно.
  progress: number;
  // Пауза на 214°: зерно тріснуло й тримає тріщини до перезапуску циклу.
  cracked: boolean;
}

// Один requestAnimationFrame-годинник на лічильник і зерно в Hero, щоб колір,
// масштаб і тріск зерна йшли синхронно з температурою.
export function useRoastCounter() {
  const [clock, setClock] = useState<RoastClock>({ temp: START, progress: 0, cracked: false });

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setClock({ temp: END, progress: 1, cracked: true });
      return;
    }
    let frame = 0;
    let startedAt = performance.now();

    const tick = (now: number) => {
      const elapsed = now - startedAt;
      const progress = Math.min(1, elapsed / (RISE_MS + HOLD_MS));
      if (elapsed <= RISE_MS) {
        setClock({
          temp: START + (END - START) * smoothstep(elapsed / RISE_MS),
          progress,
          cracked: false,
        });
      } else if (elapsed <= RISE_MS + HOLD_MS) {
        setClock({ temp: END, progress, cracked: true });
      } else {
        startedAt = now;
      }
      frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, []);

  const isFirstCrack = clock.temp >= 213.4;
  const stage = isFirstCrack ? 'FIRST CRACK' : clock.temp >= 196 ? 'РОЗВИТОК' : 'СУШІННЯ';

  return { ...clock, stage, isFirstCrack };
}

export type RoastCounterState = ReturnType<typeof useRoastCounter>;
